module.exports = __webpack_public_path__ + "assets/media/1.bd5df8a2.wav";